import { createSlice } from "@reduxjs/toolkit";
import { getEBLConsent } from "../action/ProfileAccount";

export interface EBLConsentProfile {
  id: number;
  partnerId: number;
  firstSignatory: string;
  secondSignatory: string;
  firstJobTitle: string;
  secondJobTitle: string;
  firstDate: string;        // LocalDate → ISO string
  secondDate: string;       // LocalDate → ISO string
  filePath: string;
  submittedBy: string;
  createdAt: string;        // OffsetDateTime → ISO string
}

interface EBLConsentProfileState {
  loading: boolean;
  data: EBLConsentProfile | null;
  error: any;
}

const initialState: EBLConsentProfileState = {
  loading: false,
  data: null,
  error: null,
};

const eblConsentProfileSlice = createSlice({
  name: "eblConsentProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEBLConsent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEBLConsent.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEBLConsent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as any;
      });
  },
});

export default eblConsentProfileSlice.reducer;
